export interface ApiKeyProfile {
    apiKey: string;
    apiKeyName: string;
    lastUsed: number;
    createAt: number;
    apiLimitPerMinute: number;
    apiLimitPerHour: number;
    apiLimitPerDay: number;
    apiLimitPerMonth: number;
};